import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type AccountEditorTableViewerFragment = { __typename?: 'Viewer', plan: Types.Plan, channels: Array<{ __typename?: 'ChannelItem', id: Types.Channel, name: string }> };

export const AccountEditorTableViewerFragmentDoc = gql`
    fragment AccountEditorTableViewer on Viewer {
  plan
  channels {
    id
    name
  }
}
    `;